import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TopProgressBarService } from '@shared/services/top-progress-bar.service';

@Component({
  selector: 'top-bar-progress-bar',
  templateUrl: './top-progress-bar.component.html',
  styleUrls: ['./top-progress-bar.component.scss'],
  imports: [CommonModule, MatProgressBarModule],
  standalone: true
})
export class TopProgressBarComponent {
  service: TopProgressBarService = inject(TopProgressBarService);
}
